<template>
  <div class="flex min-h-screen bg-gray-100">
    <!-- Боковая панель (Sidebar) -->
    <aside class="w-64 bg-gray-900 text-white p-6">
      <h1 class="text-2xl font-bold mb-8">📱 PhoneRepair</h1>
      <p class="text-xs text-gray-400 mb-8">АДМИН ПАНЕЛЬ</p>

      <!-- Меню -->
      <nav class="space-y-2">
        <router-link
          to="/admin"
          class="block px-4 py-3 rounded hover:bg-gray-800 transition"
          :class="{ 'bg-blue-600': isActive('/admin') }"
        >
          📊 Dashboard
        </router-link>

        <router-link
          to="/admin/services"
          class="block px-4 py-3 rounded hover:bg-gray-800 transition"
          :class="{ 'bg-blue-600': isActive('/admin/services') }"
        >
          🔧 Услуги
        </router-link>

        <router-link
          to="/admin/orders"
          class="block px-4 py-3 rounded hover:bg-gray-800 transition"
          :class="{ 'bg-blue-600': isActive('/admin/orders') }"
        >
          📦 Заказы
        </router-link>

        <router-link
          to="/admin/users"
          class="block px-4 py-3 rounded hover:bg-gray-800 transition"
          :class="{ 'bg-blue-600': isActive('/admin/users') }"
        >
          👥 Пользователи
        </router-link>

        <router-link
          to="/admin/reports"
          class="block px-4 py-3 rounded hover:bg-gray-800 transition"
          :class="{ 'bg-blue-600': isActive('/admin/reports') }"
        >
          📈 Отчеты
        </router-link>
      </nav>

      <!-- Выход -->
      <div class="mt-8 pt-8 border-t border-gray-700">
        <button
          @click="logout"
          class="w-full px-4 py-3 bg-red-600 hover:bg-red-700 rounded transition"
        >
          🚪 Выход
        </button>
      </div>

      <!-- Информация админа -->
      <div class="mt-8 pt-8 border-t border-gray-700 text-xs">
        <p class="text-gray-400">Вошли как:</p>
        <p class="font-bold text-white mt-1">{{ currentUser?.name }}</p>
        <p class="text-gray-500 mt-1">{{ currentUser?.email }}</p>
      </div>
    </aside>

    <!-- Основной контент -->
    <main class="flex-1">
      <!-- Топ бар -->
      <div class="bg-white shadow px-8 py-4 flex justify-between items-center">
        <h2 class="text-2xl font-bold">{{ pageTitle }}</h2>
        <div class="text-sm text-gray-600">
          {{ currentDate }}
        </div>
      </div>

      <!-- Содержимое страницы -->
      <div class="p-8">
        <router-view />
      </div>
    </main>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useAuthStore } from './stores/auth';

export default {
  name: 'AdminLayout',
  setup() {
    const router = useRouter();
    const route = useRoute();
    const authStore = useAuthStore();

    const currentDate = ref('');

    const currentUser = computed(() => authStore.user);

    const pageTitle = computed(() => {
      const titles = {
        '/admin': '📊 Dashboard',
        '/admin/services': '🔧 Управление услугами',
        '/admin/orders': '📦 Управление заказами',
        '/admin/users': '👥 Пользователи',
        '/admin/reports': '📈 Отчеты'
      };
      return titles[route.path] || 'Admin Panel';
    });

    const isActive = (path) => {
      return route.path === path || route.path.startsWith(path + '/');
    };

    const logout = () => {
      authStore.logout();
      router.push('/');
    };

    const updateDate = () => {
      const now = new Date();
      const options = { 
        weekday: 'long', 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      };
      currentDate.value = now.toLocaleDateString('uk-UA', options);
    };

    onMounted(() => {
      updateDate();
      setInterval(updateDate, 60000); // Обновлять каждую минуту
    });

    return {
      currentUser,
      pageTitle,
      isActive,
      logout,
      currentDate
    };
  }
};
</script>
